/**
 * Just an img element.
 * Create the img on the fly to control order of image loading (vs. replacing the src of existing img)
 */

var Backbone = require('backbone');

require('CRE');
require('jquery.ui.effect'); // for remove class with time !!! otherwise fade in


module.exports = Backbone.View.extend({
    tagName: 'img',
    className: 'FV-pgImg',

    // Note: model required
    initialize: function(options) {

        this.model = options.model;
        this.imgLoadTimer = null;
        this.undelegateEvents(); // start turned off
        _.bindAll(this, 'nonCREError');

    },

    events: {
        'load':     'imgLoaded',
        'error':    'nonCREError' // error loading the image -- not from cre (eg: 404 not found)
    },

    /*
    * Set the src of the img with URL returned from CRE.
    * Note: not in DOM when set src.
    * Timer: 800 WORKING for firefox with node 10 timeout -- timing issue occurring --- the lower the timeout in node server,
    * lower this must be for firefox -- can we lower this ?
    * */
    loadImg: function(imgUrl) {

        this.delegateEvents();
        var pm = this.model,
            $el = this.$el,
            imgLoadTimer = this.imgLoadTimer = setInterval(function() {
                if ( pm.get('isLoaded') ) {
                    clearInterval(imgLoadTimer);
                    return;
                }
                $el.attr('src', imgUrl);
         }, 800) ;

    },
    imgLoaded: function() {
        this._cleanUp();
        this.model.set({'isLoaded': true});
    },
    nonCREError: function(e) {
        this.model.trigger('imgLoadError', e);
    },
    onAbortImageRequestOnErr: function() {
        this._cleanUp();
    },
    _cleanUp: function() {
        clearInterval(this.imgLoadTimer); //( !prevent subsequent image requests that will hang)
        this.undelegateEvents();
    },

    destroy: function() {
        this._cleanUp();
        this.remove();


        /* for resolving leaks w/ jq cache*/
        this.el = null;
        this.$el = null;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/creImage.js
 ** module id = 420
 ** module chunks = 0
 **/